export default __webpack_public_path__ + "static/media/Stella_9781843628699.056a286f.jpg";